<script>
/**
 * 关于我们（自 vancheen-b2b 的 AboutView.vue 移植为 Vue 2 版本）
 * 结构：page-hero → 公司简介（分栏）→ 使命/愿景/价值观 → 关键里程碑 → CTA
 */
import NhShell from '../components/NhShell.vue'
import NhCtaBand from '../components/NhCtaBand.vue'
import NhFeatureCard from '../components/NhFeatureCard.vue'
import NhPageHero from '../components/NhPageHero.vue'
import NhSectionHead from '../components/NhSectionHead.vue'
import { getSite } from '../nh-site-data'
import { t, setPageTitle } from '../nh-i18n'

export default {
  name: 'NhAboutPage',
  components: {
    NhShell,
    NhCtaBand,
    NhFeatureCard,
    NhPageHero,
    NhSectionHead,
  },
  computed: {
    ABOUT_INTRO() {
      return getSite('ABOUT_INTRO')
    },
    ABOUT_VALUES() {
      return getSite('ABOUT_VALUES')
    },
    ABOUT_MILESTONES() {
      return getSite('ABOUT_MILESTONES')
    },
    CTA_ABOUT() {
      const cta = getSite('CTA')
      return cta ? cta.about : { title: '', desc: '', actions: [] }
    }
  },
  mounted() {
    setPageTitle('about')
  },
  methods: {
    t
  }
}
</script>

<template>
  <NhShell>
    <NhPageHero
      :crumbs="[{ label: t('crumbs.home'), to: '/' }, { label: t('about.crumb') }]"
      :title="t('about.title')"
      :desc="t('about.desc')"
    />

    <!-- ===== 使命 / 愿景 / 价值观 ===== -->
    <section class="section bg-gray">
      <div class="container">
        <NhSectionHead :kicker="t('about.valuesKicker')" :title="t('about.valuesTitle')" />
        <div class="features-grid">
          <NhFeatureCard
            v-for="(item, i) in ABOUT_VALUES"
            :key="item.title"
            :icon="item.icon"
            :title="item.title"
            :desc="item.desc"
            :delay="i || undefined"
          />
        </div>
      </div>
    </section>

    <!-- ===== 关键里程碑 ===== -->
    <section class="section">
      <div class="container">
        <NhSectionHead :kicker="t('about.milestonesKicker')" :title="t('about.milestonesTitle')" />
        <div class="features-grid">
          <NhFeatureCard
            v-for="(item, i) in ABOUT_MILESTONES"
            :key="item.title"
            :icon="item.icon"
            :title="item.title"
            :desc="item.desc"
            :delay="i || undefined"
          />
        </div>
      </div>
    </section>

    <!-- ===== CTA ===== -->
    <NhCtaBand
      :title="CTA_ABOUT.title"
      :desc="CTA_ABOUT.desc"
      :actions="CTA_ABOUT.actions"
    />
  </NhShell>
</template>
